import * as React from 'react';
import { connect } from 'react-redux';
import { RefreshControl, Platform, FlatList, StyleSheet } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View } from 'native-base';
import * as Contacts from 'expo-contacts';
import * as Permissions from 'expo-permissions';
import * as _ from 'lodash';

import Modal from './modal';
import Alert from './alert';

import CalCalDataApi from '../api/CalCalDataApi';
import PhoneContact from './phoneContactListItem';

//Renders a flatlist of contacts from phone; on select calls props.onSelectCustomer

class PhoneContactsList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			contacts: [],
			latestPage: 0,
			isModalVisible: true,
			selected: new Map(),
			selecting: false,
			permission: null,
			loading: true
		};
	}

	componentDidMount() {
		//fire off async call first page

		this.getContactsAsync();
	}

	async getContactsAsync() {
		const pageSize = 200;

		__DEV__ && console.log('getContactsAsync permission, page', this.state.permission, this.state.latestPage);
		if (!this.state.permission) {
			// Ask for permission to query contacts.
			const permission = await Permissions.askAsync(Permissions.CONTACTS);
			__DEV__ && console.log(permission);
			if (permission.status !== 'granted') {
				// Permission was denied...
				this.setState({ permission: false });
				return;
			} else {
				this.setState({ permission: true });
			}
		}

		if (this.state.hasNextPage === false) return;
		const latestPage = this.state.latestPage;
		this.state.latestPage = latestPage + 1; //prevent fetching while setting state
		this.setState({ loading: true });

		const contacts = await Contacts.getContactsAsync({
			fields: [Contacts.PHONE_NUMBERS, Contacts.EMAILS, Contacts.NOTE],
			sort: 'firstName',
			pageSize: pageSize,
			pageOffset: latestPage * pageSize
		});
		const sortedContacts = _.filter(contacts.data, 'name'); // _.uniqBy(contacts.data, 'id');

		//console.log(sortedContacts);

		this.setState({ contacts: [...this.state.contacts, ...sortedContacts], hasNextPage: contacts.hasNextPage, loading: false });

		/*if (contacts.total > 0) {
		Alert.alert(
		  'Your first contact is...',
		  `Name: ${contacts.data[0].name}\n` +
		  `Phone numbers: ${JSON.stringify(contacts.data[0].phoneNumbers)}\n` +
		  `Emails: ${JSON.stringify(contacts.data[0].emails)}`
		);
	  }*/
	}

	renderItem({ item, selecting }) {
		//console.log('renderitem', item);
		//const selected = !!selected[item.id];
		//const { selecting } = this.state;
		//if (!item.name) return null;
	}

	renderFooter = () => {
		if (!this.state.loading) return null;

		return (
			<View
				style={{
					paddingVertical: 20,
					borderTopWidth: 1,
					borderColor: '#CED0CE'
				}}>
				<Spinner />
			</View>
		);
	};

	//_keyExtractor = (item, index) => item.id;

	_onTapItem(item) {
		if (!!this.state.selecting) return this._onTickItem(item);
		//this.props.onSelectCustomer && this.props.onSelectCustomer(item);
		__DEV__ && console.log(item);
		//want to save item(s)
		if (this.saveContact(item)) this.props.closure();
	}

	_onTickItem = item => {
		__DEV__ && console.log('longClick', item);
		if (!this.state.selecting) this.setState({ selecting: true });
		// updater functions are preferred for transactional updates
		/*this.setState(state => {
			// copy the map rather than modifying state.
			const selected = new Map(state.selected);
			selected.set(id, !selected.get(id)); // toggle
			return { selected };
		});*/
		item.selected = !item.selected;
		//item.selectedClass = item.isSelect ? styles.selected : styles.list;
		const index = this.state.contacts.findIndex(it => it.id === item.id);
		this.state.contacts[index] = item;
		this.setState({
			contacts: this.state.contacts
		});

		this.setState(oldState => ({
			selected: {
				// New instance breaks `===`
				...oldState.selected, // copy old data
				[index]: !oldState.selected[index] // toggle
			}
		}));
	};

	async saveContact(contact) {
		//console.log('getting contact id', id);
		//const contact = await Expo.Contacts.getContactByIdAsync({ fields: [Expo.Contacts.PHONE_NUMBERS, Expo.Contacts.EMAILS, Expo.Contacts.NOTE, Expo.Contacts.ADDRESSES], id: '3884' });
		__DEV__ && console.log(contact);
		//map contact fileds to new customer/supplier
		const phone =
			contact.phoneNumbers && contact.phoneNumbers.length > 1 ? _.find(contact.phoneNumbers, { primary: true }) || contact.phoneNumbers[0] : contact.phoneNumbers && contact.phoneNumbers[0];

		const email = contact.emails && contact.emails.length > 1 ? _.find(contact.emails, { primary: true }) || contact.emails[0] : contact.emails && contact.emails[0];
		//const address =

		const values = {
			name: contact.name,
			businessName: contact.company,
			notes: contact.note,
			address1: contact.addresses && contact.addresses[0] && contact.addresses[0].formattedAddress,
			address2: contact.addresses && contact.addresses[0] && contact.addresses[0].street,
			city: contact.addresses && contact.addresses[0] && contact.addresses[0].city,
			postcode: contact.addresses && contact.addresses[0] && contact.addresses[0].postalCode,
			tel: phone && phone.number,
			email: email && email.email
		};
		__DEV__ && console.log('SUBITTing', values);

		return CalCalDataApi.dataInsert(this.props.personType + 's', values, this.props.jwt, res => {
			__DEV__ && console.log('handleSubmit ', res);
			if (res.success) {
				this.insertId = res.id;
				this.props.dispatch({
					type: 'INSERT/' + this.props.personType, //successful update send UPDATE(d) to store
					values: res.record //{...values, id:res.id}						//HAS to include response for correct ID
				});
				return true;
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
				return false;
				//throw new SubmissionError(res.validationErrors);
			} else {
				Alert.alert('Save failed, error ' + res.error, res.message);
				return false;
				//throw new SubmissionError(res.error);
			}
		});
	}

	saveSelections() {
		_.forIn(this.state.selected, (val, key) => {
			this.saveContact(key);
		});
		this.props.closure();
	}

	renderItem({ item }) {
		return <PhoneContact item={item} key={item.id} selecting={this.state.selecting} onPress={s => this._onTapItem(s)} onLongPress={l => this._onTickItem(l)} />;
	}

	getItemLayout(data, index) {
		const ITEM_HEIGHT = 44;
		return { length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index };
	}

	render() {
		const { selecting, selected, permission } = this.state;
		return (
			<Modal isOpen={this.state.isModalVisible} swipeToClose={false} backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={() => this.props.closure()}>
				<Header style={styles.modalHeader}>
					<Left>
						<Button transparent onPress={() => this.setState({ isModalVisible: false })}>
							<Icon name="close" />
						</Button>
					</Left>
					<Body>
						<Title>Import {this.props.personType} contacts</Title>
					</Body>

					{selecting ? (
						<Button transparent onPress={() => this.saveSelections()}>
							<Icon style={{ color: 'green' }} name="download" />
						</Button>
					) : (
						<Button transparent onPress={() => this.setState({ selecting: true })}>
							<Icon name="checkbox" />
						</Button>
					)}
				</Header>
				<View style={styles.modalContainer}>
					<View style={styles.innerContainer}>
						{permission ? (
							<FlatList
								data={this.state.contacts}
								extraData={(selecting, selected)}
								initialNumToRender={15}
								//selected={this.state.selected}
								getItemLayout={this.getItemLayout}
								//refreshing={data.networkStatus === 4}
								//onRefresh={() => data.refetch()}
								//FlatListItemSeparator={() => <View style={styles.line} />}
								onEndReachedThreshold={8}
								onEndReached={() => {
									this.getContactsAsync();
								}}
								renderItem={this.renderItem.bind(this)}
								ListFooterComponent={this.renderFooter}
								maxToRenderPerBatch={16}
								windowSize={16}
							/>
						) : Platform.OS == 'web' ? (
							<Text>Use the CalCal app to import contacts from your phone!</Text>
						) : (
							<Text>Waiting for permission to retrieve your contacts</Text>
						)}
						{!permission && (
							<Button style={{ margin: 20 }} onPress={() => this.getContactsAsync()}>
								<Text>Try again</Text>
							</Button>
						)}
					</View>
				</View>
			</Modal>
		);
	}
}

const styles = StyleSheet.create({
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: '95%'
	},
	modalContainer: {
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 35,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});

const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	suppliers: state.globalReducer.suppliers,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});

export default connect(mapStateToProps)(PhoneContactsList);
